// extracted by mini-css-extract-plugin
module.exports = {"color":"Toolbar_color__1V-4I","button":"Toolbar_button__1sLvX"};